// extracted by mini-css-extract-plugin
export default {"pill":"styles-module__pill__src-labstep-web-core-Dropdown-Pill-Trigger-_T4cwD"};